import { render, staticRenderFns } from "./invoice-notes.vue?vue&type=template&id=1f42d5de"
import script from "./invoice-notes.vue?vue&type=script&lang=js"
export * from "./invoice-notes.vue?vue&type=script&lang=js"
import style0 from "./invoice-notes.vue?vue&type=style&index=0&id=1f42d5de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports